import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom'; // Added for routing
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import ProjectsSection from './components/ProjectsSection';
import TechnologiesSection from './components/TechnologiesSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ServiceModal from './components/ServiceModal';
import { Service } from './components/ServicesSection';
import BlogPage from './components/BlogPage'; // Placeholder for Blog page component
import BlogPostDetailsPage from './components/BlogPostDetailsPage'; // Added for single post view
import SuccessStoryPage from './components/SuccessStoryPage'; // Added for success stories

// Main CSS import (if not already in index.tsx, though index.tsx is preferred for global CSS)
// import './index.css'; 

// Component for the main landing page content
const HomePageLayout = ({ onOpenContactModal, onOpenServiceModal }: {
  onOpenContactModal: () => void;
  onOpenServiceModal: (service: Service) => void;
}) => (
  <>
    <HeroSection onOpenContactModal={onOpenContactModal} />
    <ServicesSection onOpenContactModal={onOpenContactModal} onOpenServiceModal={onOpenServiceModal} />
    <WhyChooseUsSection /> 
    <ProjectsSection />
    <TechnologiesSection />
    <CTASection onOpenContactModal={onOpenContactModal} />
  </>
);

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<Service | null>(null);

  const openContactModal = () => {
    closeServiceModal();
    setIsContactModalOpen(true);
  };
  const closeContactModal = () => setIsContactModalOpen(false);

  const openServiceModal = (service: Service) => {
    closeContactModal();
    setSelectedService(service);
  };
  const closeServiceModal = () => setSelectedService(null);

  return (
    <div className="min-h-screen bg-gray-900 text-white"> {/* Base background and text color */}
      <Navbar onOpenContactModal={openContactModal} />
      <main>
        <Routes>
          <Route 
            path="/"
            element={<HomePageLayout onOpenContactModal={openContactModal} onOpenServiceModal={openServiceModal} />}
          />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostDetailsPage />} /> {/* Added route for single blog post */}
          <Route path="/success-stories/:slug" element={<SuccessStoryPage />} /> {/* Added route for success stories */}
          {/* Add more routes here as needed, e.g., for individual blog posts /blog/:slug */}
        </Routes>
      </main>
      <Footer onOpenContactModal={openContactModal} onOpenServiceModal={openServiceModal} />
      <ContactSection isOpen={isContactModalOpen} onClose={closeContactModal} />
      {selectedService && (
        <ServiceModal 
          isOpen={!!selectedService}
          onClose={closeServiceModal}
          title={selectedService.title}
          longDescription={selectedService.longDescription || ''}
          imageUrl={selectedService.imageUrl || ''}
        />
      )}
    </div>
  );
}

export default App; 